import React, {useContext} from 'react';
import './Sidebarstyle.css';
import { AppContext } from '../../context/AppContext';
import { NavLink, useNavigate } from 'react-router-dom';

export default function Sidebar(props) {

  const tokenData = useContext(AppContext);
  const navigate = useNavigate();

  return (
    <aside className='sidebar-main-div'>
      
      {/* renders sidebar options */}
        {props.menuOptions.map((menu, index) => (
              menu.roles.includes(tokenData.roleID) ? 
              <NavLink key={menu.id} to={menu.path} className={'normal'}>
                  <p onClick={() => {
                    //console.log(window.location.pathname === menu.path);
                    if(window.location.pathname === menu.path){
                      navigate(0);
                    }
                    //console.log(menu.path);
                  }}>{menu.iconType !== 'fa' ? <img className='svg-icon' src={menu.icon} /> : <i className={`fa ${menu.icon} custom-color fa-lg`} aria-hidden="true"></i>}<span style={{marginLeft:'18px'}}>{menu.label !== undefined ? menu.label : ''}</span></p>
              </NavLink> : null
        ))}

    </aside>
  )
}
